import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectProps } from '@mui/material/Select';

type Props = SelectProps & {
  helperText?: string;
};

const SelectField = (props: Props): React.JSX.Element => {
  const { helperText, ...forwardProps } = props;

  return (
    <FormControl fullWidth>
      {forwardProps.label && <InputLabel id="test-select-label">{forwardProps.label}</InputLabel>}
      <Select {...forwardProps} />
      {props.helperText && (
        <FormHelperText error={forwardProps.error} className="select-field-helper-text">
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default SelectField;
